import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { MdTranslate } from 'react-icons/md'

import { UserContext } from '../../contexts/UserContext'
import { LanguageContext } from '../../contexts/LanguageContext'
import AuthButton from '../AuthButton'

function NavLink({ setIsOpen }) {
  const navigate = useNavigate()
  const { user, setUser } = useContext(UserContext)
  const { language } = useContext(LanguageContext)

  if (!user) {
    return (
      <>
        <button
          className="nav-link"
          onClick={() => {
            navigate('/')
            setIsOpen(false)
          }}
        >
          Home
        </button>

        <button
          className="nav-link"
          onClick={() => {
            navigate('/translate')
            setIsOpen(false)
          }}
        >
          <MdTranslate /> {language?.language}
        </button>

        <button className="nav-link">
          <AuthButton />
        </button>
      </>
    )
  }

  return (
    <>
      <button className="nav-link" onClick={() => navigate('/all')}>
        Cashier
      </button>

      {user?.is_manager && (
        <button className="nav-link" onClick={() => navigate('/manage/sales')}>
          Manage
        </button>
      )}

      <button
        className="nav-link"
        onClick={() => {
          setUser()
          navigate('/')
        }}
      >
        Sign Out as {user.employee_name}
      </button>
    </>
  )
}

export default NavLink
